module.exports = __webpack_public_path__ + "media/images/emblems/La_Tour-de-Peilz-coat_of_arms-1ec70324d6ea2b4cb1878daa99373760.svg";